import { render, staticRenderFns } from "./QualityAnalytics.vue?vue&type=template&id=2bd00f7d&scoped=true"
import script from "./QualityAnalytics.vue?vue&type=script&lang=js"
export * from "./QualityAnalytics.vue?vue&type=script&lang=js"
import style0 from "./QualityAnalytics.vue?vue&type=style&index=0&id=2bd00f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd00f7d",
  null
  
)

export default component.exports